<template>
  <div class="content-box">
    <Loader v-if="loading" />
    <div class="full-chat-w" v-else>
      <div class="full-chat-i">
        <div class="full-chat-left scrollable">
          <div class="os-tabs-w os-tab">
            <ul class="nav nav-tabs upper centered">
              <li class="nav-item">
                <a class="nav-link active" data-toggle="tab" @click="selectedQueue='photodesk'">
                  <i class="fal fa-camera"></i>
                  <span>Photodesk Queue</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" @click="selectedQueue='all'">
                  <i class="fal fa-list"></i>
                  <span>All Products</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="chat-search">
            <div class="element-search"><input placeholder="Search products..." type="text" v-on:keyup.enter="searchRMS()" v-model="searchString"></div>
          </div>
          <div class="ae-list-w">
            <div class="ael-head">
              <div class="actions-left">
                <h5>{{pendingProducts.length}} Products</h5>
                <!-- <div class="input-search-w"><input class="form-control rounded bright" @input="isTyping = true" v-model="searchString"  placeholder="Type to filter..." type="search"></div> -->
              </div>
              <div class="actions-right">
                <a @click="refreshProductRail">
                  <i class="os-icon os-icon-grid-18" :class="{'fa fa-spin' :  loadingPendingRail}"></i>
                </a>
              </div>
            </div>
            <div class="ae-list">
              <Loader v-if="loadingPendingRail" />
              <ProductRail :products="pendingProducts" :selectedProduct="selectedProduct" @productRailInterface="updateSelectedProduct" v-else/>
            </div>
          </div>
        </div>
        <div class="full-chat-right scrollable border-right">
          <EmptyState v-if="selectedProduct == ''">
            <div slot="empty_state_text">
              Select a product to see details
            </div>
          </EmptyState>
          <ProductInfoBlock :selectedProduct="selectedProduct" :session="session" :type="'copydesk'" v-else/>
        </div>
        <div class="full-chat-middle">
          <div class="chat-head">
            <div class="user-info">
              <div v-if="isCopyDuplicate == true">
                <button class="mr-2 mb-2 btn btn-success btn-sm" type="button" @click="actionCopyDuplicateChange(1)" > Accept Changes</button>
                <button class="mr-2 mb-2 btn btn-danger btn-sm" type="button" @click="actionCopyDuplicateChange(0)" > Revert Changes</button>
              </div>
              <div v-show="loadingProduct == false && waitingForAction == false && revisionFilters.selected == 'current_draft' && isCopyDuplicate == false">
                <button class="mr-2 mb-2 btn btn-success btn-sm" type="button" @click="actionPendingProduct" > Save Draft</button>
                <button class="mr-2 mb-2 btn btn-primary btn-sm" type="button" @click="submitForReview" > Submit for Review</button>
              </div>
            </div>
            <div class="user-actions" v-if="waitingForAction == false">
              <button class="mr-2 mb-2 btn btn-primary btn-sm" type="button" @click="showComments=!showComments" > 
                {{ showComments == false ? 'View Comments' : 'View Copy'}}
              </button>
              
              <!-- <div class="list-order">
                <select v-model="revisionFilters.selected" v-on:change="onFilterRevisionChange">
                  <option value="current_draft" selected>Current Draft</option>
                  <option v-for="option in revisionFilters.filterOptions" :value="option.key" @change="updateRevision(option)">{{option.value}}</option>
                </select>
              </div> -->
            </div>
          </div>
          <div class="chat-content-w">
            <EmptyState v-if="waitingForAction">
              <div slot="empty_state_text" v-if="pendingProducts.length > 0">
                Select a product to continue
              </div>
              <div slot="empty_state_text" v-else>
                There are no products in queue
              </div>
            </EmptyState>
            <ProductComments v-else-if="showComments" :comments="productComments" />
            <div v-else>
              <Loader v-if="loadingProduct || revisionFilters.loadingRevision" />
              <Workspace :product="selectedProduct" :headers="activeProductCopy" :template="selectedProductTemplate" :primaryLanguage="session.language_code" @copyInterface="updateCopyFormData" v-else-if="revisionFilters.selected == 'current_draft'" />
              <RevisionWorkspace :product="selectedProduct" :revision="revisionFilters.selectedRevision" v-else />
            </div>
          </div>
        </div>
        <div class="full-chat-right scrollable border-right">
          <EmptyState v-if="selectedProduct == ''">
            <div slot="empty_state_text">
              Select a product to see details
            </div>
          </EmptyState>
          <RelatedProductRail :selectedProduct="selectedProduct" :session="session" :type="'copydesk'" v-else/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/common/Loader'
import Placeholder from '@/components/common/Placeholder'
import EmptyState from '@/components/common/EmptyState'

import ProductRail from '@/components/common/SessionAdd/ProductRail'
import ProductInfoBlock from '@/components/common/SessionAdd/ProductInfoBlock'
import RelatedProductRail from '@/components/common/SessionAdd/RelatedProductRail'

import Workspace from '@/components/copydesk/Workspace'
import RevisionWorkspace from '@/components/copydesk/RevisionWorkspace'
import ProductComments from '@/components/productdesk/ProductComments'
import CopyRevisionModal from '@/components/copydesk/Modals/CopyRevisionModal'

import Session from '@/mixins/session'
import Product from '@/mixins/product'

import { debounce } from 'underscore'

export default {
  name: 'session-view',
  mixins: [Session, Product],
  components: {
    Loader,
    EmptyState,
    Workspace,
    RevisionWorkspace,
    ProductRail,
    Placeholder,
    ProductInfoBlock,
    RelatedProductRail,
    ProductComments
  },
  props: ['id_session'],
  data: function () {
    return {
      session: '',
      selectedQueue: 'photodesk',
      searchString: '',
      pendingProducts: [],
      selectedProduct: '',
      selectedProductCopy: '',
      selectedProductCopyDuplicated: '',

      activeProductCopy: '',

      selectedProductRevisions: '',
      selectedProductTemplate: '',
      loading: false,
      loadingPendingRail: true,
      loadingProduct: true,
      waitingForAction: true,
      revisionState: 'loading',
      revisionFilters: {
        loadingRevision: false,
        filterOptions: [],
        selected: 'current_draft',
        selectedRevision: ''
      },
      copyFormData: '',
      isFormChanged: false,
      isCopyDuplicate: false,
      productComments: [],
      showComments: false
    }
  },
  mounted: function () {
    this.getSessionDetails()
  },
  methods: {

    searchRMS () {
      if (this.selectedQueue == 'photodesk') {
        return
      }
      var self = this
      const url = '/productdesk/search'

      let data = {
        id_channel: self.session.id_channel,
        identifier: self.searchString
      }
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.pendingProducts = response.data.result
          console.log(response)
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
          self.loadingPendingRail = false
        })
    },
    removeKeys (obj, keys) {
      var self = this
      var index
      for (var prop in obj) {
        // important check that this is objects own property
        // not from prototype prop inherited
        if (obj.hasOwnProperty(prop)) {
          switch (typeof (obj[prop])) {
            case 'string':
              index = keys.indexOf(prop)
              if (index > -1) {
                delete obj[prop]
              }
              break
            case 'object':
              index = keys.indexOf(prop)
              if (index > -1) {
                delete obj[prop]
              } else {
                self.removeKeys(obj[prop], keys)
              }
              break
          }
        }
      }
    },
    updateCopyFormData (data) {
      this.removeKeys(data, ['children', 'options'])
      this.copyFormData = data
      this.isFormChanged = true
    },
    getSessionDetails: function () {
      var self = this

      const url = '/copydesk/session/show'
      let data = {
        id_copydesk_session: self.id_session
      }

      self.$store.dispatch('updateLoading', 'true')
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
          // mode: 'no-cors',
        })
        .then(function (response) {
          self.session = response.data.session
          self.getPendingProducts()
          self.$store.dispatch('updateLoading', 'false')
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateLoading', 'false')
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
        })
    },
    getPendingProducts: function () {
      if (this.selectedQueue != 'photodesk') {
        self.pendingProducts = []
        return
      }

      var self = this
      var search =
        this.searchString != '' ? '&search=' + this.searchString : ''

      const url = '/copydesk/session/products/pending/write'
      let data = {
        id_copydesk_session: self.session.id_copydesk_session,
        queue: self.selectedQueue
      }

      self.loadingPendingRail = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.pendingProducts = response.data
          self.loadingPendingRail = false
        })
        .catch(function (error) {
          // add toast message
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
          self.loadingPendingRail = false
        })
    },
    actionPendingProduct: function () {
      var self = this
      const url = '/copydesk/product/revision/add'

      let data = {
        id_copydesk_session: self.id_session,
        id_product: self.selectedProduct.id_product,
        copy_data: self.copyFormData
      }
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          console.log(response)
          self.$store.dispatch('updateToast', {
            text: 'Draft saved',
            show: true
          })
          self.getProductInformation()
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
          self.loadingPendingRail = false
        })
    },
    submitForReview: function () {
      var self = this

      const url = '/copydesk/product/submit'

      let data = {
        id_copydesk_session: self.id_session,
        id_product: self.selectedProduct.id_product
      }
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          console.log(response)
          self.$store.dispatch('updateToast', {
            text: 'Draft submitted',
            show: true
          })
          self.getProductInformation()
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
          self.loadingPendingRail = false
        })
    },
    getProductInformation: function () {
      var self = this
      const url = '/copydesk/product/details/'
      let data = {
        id_product: self.selectedProduct.id_product,
        id_client_rms: self.selectedProduct.id_client_rms,
        id_photodesk_session: self.selectedProduct.id_photodesk_session
      }

      this.loadingProduct = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.isCopyDuplicate = false
          self.selectedProduct = response.data.product

          self.selectedProductCopy = response.data.product_copy
          self.activeProductCopy = response.data.product_copy

          self.selectedProductRevisions = response.data.copy_revisions
          self.selectedProductTemplate = response.data.copy_template
          self.getFilterOptions()
          self.getProductComments()
          self.loadingProduct = false
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateToast', {
            text:
             'Copy details not found',
            show: true
          })
          self.loadingProduct = false
        })
    },
    refreshProductRail: function () {
      this.getPendingProducts()
      this.selectedProduct = ''
      this.waitingForAction = true
      this.revisionFilters.selected = 'current_draft'
    },
    updateSelectedProduct: function (data) {
      this.selectedProduct = data
      this.getProductInformation()
      this.waitingForAction = false
      this.revisionFilters.selected = 'current_draft'
    },
    getFilterOptions: function () {
      var self = this
      self.revisionFilters.selectedRevision = ''
      self.revisionFilters.filterOptions = []
      self.selectedProductRevisions.forEach(function (revision, index) {
        let obj = self.revisionFilters.filterOptions.find(
          o => o.key === revision.id_copydesk_session
        )
        if (obj == null || obj == '' || obj == undefined) {
          self.revisionFilters.filterOptions.push({
            value: 'Session ' + revision.id_copydesk_session,
            key: revision.id_copy_revision
          })
        }
      })
    },
    updateRevision: function (revision) {
      var self = this
      self.revisionFilters.loadingRevision = true
      const filter = self.revisionFilters.filterOptions.find(value => {
        return value.key == revision
      })
      console.log(filter)
      if (filter && filter.key) {
        self.revisionFilters.selectedRevision = filter.key
      } else {
        self.revisionFilters.selectedRevision = ''
      }

      if (filter && filter.value) {
        self.revisionFilters.selected = filter.value
      } else {
        self.revisionFilters.selectedRevision = 'current_draft'
      }

      self.revisionFilters.loadingRevision = false
    },
    onFilterRevisionChange: function () {
      var self = this
      this.updateRevision(self.revisionFilters.selected)
    },

    actionCopyDuplicateChange: function (accept) {
      if (accept == 1) {
        this.selectedProductCopy = this.selectedProductCopyDuplicated
        this.activeProductCopy = this.selectedProductCopyDuplicated
        this.isCopyDuplicate = false
      } else {
        this.activeProductCopy = this.selectedProductCopy
        this.isCopyDuplicate = false
      }
    }
  },
  watch: {
    '$store.state.duplicateProductCopy': function () {
      if (this.$store.getters.duplicateProductCopy.selectedProductCopy !== {}) {
        this.selectedProductCopyDuplicated = this.$store.getters.duplicateProductCopy.selectedProductCopy
        this.activeProductCopy = this.selectedProductCopyDuplicated
        this.isCopyDuplicate = true
      }
    },
    selectedQueue () {
      this.refreshProductRail()
    }
  }
}
</script>

<style scoped>
.full-chat-w .full-chat-right {
  flex: 0 0 300px;
}
.full-chat-w .user-intro .user-intro-info {
  margin-top: 14px !important;
}
.border-right {
  border-right: 1px solid #f6f7f8;
}
.full-chat-w .full-chat-left .os-tabs-w .nav {
  padding: 0px 20px;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.full-chat-w .full-chat-left .chat-search {
  padding-top: 80px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.full-chat-w .chat-content-w {
  height: calc(100vh - 98px);
  overflow-y: scroll;
  position: relative;
}
.qc-1 {
  color: #75da62 !important;
}

.qc-0 {
  color: #da6262 !important;
}

.flagged {
  color: #ffc107 !important;
}
.ae-list-w {
  background-color: #f2f4f8;
}
.element-wrapper .element-search input {
  background-color: #fff;
  border-radius: 0px !important;
}

.full-chat-w .full-chat-left {
  padding: 0px !important;
}

.element-wrapper {
  padding-bottom: 0rem !important;
}

.os-tab {
  position: absolute;
  top: 0;
  width: 340px;
  background: #f2f4f8;
  z-index: 999;
}

.tab-container {
  margin-top: 53px;
}

.side-section .side-section-content {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 20px 0px;
}

.property-side-features .feature {
  padding: 15px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  font-size: 0.72rem;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 1px;
}

.property-side-features .feature i,
.property-side-features .feature span,
.property-side-features .feature strong {
  display: inline-block;
  vertical-align: middle;
}

.property-side-features .feature span {
  color: rgba(0, 0, 0, 0.6);
}

.property-side-features .feature strong {
  margin-right: 3px;
  color: #111;
}

.property-side-features .feature i {
  color: #047bf8;
  font-size: 15px;
  margin-right: 20px;
}

.property-side-features .feature:last-child {
  border-bottom: none;
}
.user-name {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.user-title {
  margin-bottom: 4px;
}
.user-role {
  font-size: 0.63rem;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.4);
  margin-bottom: 10px;
}

.chat-head {
  min-height: 53px;
}
</style>
